function addRestApiCall(id) {
	return {
		type: 'ADD_REST_API_CALL',
		payLoad: {
			id
		}
	}
}

function removeRestApiCall(endpointId, restCallId) {
	return {
		type: 'REMOVE_REST_API_CALL',
		payLoad: {
			endpointId,
			restCallId
		}
	}
}

export { addRestApiCall, removeRestApiCall };
